"use client";

import React from "react";

export function AboutUsBanner() {
  return (
    <section id="relume" className="relative px-[5%] py-16 md:py-24 lg:py-28 text-white h-[550px] bg-[rgba(0,0,0,0.4)] ] ">
      <div className="container flex items-center  md:max-w-5xl lg:max-w-7xl mx-auto relative z-1">
        <div className="w-full max-w-4xl backdrop-blur-[2px] p-10 -ml-10 rounded-xl drop-shadow-2xl">
          <h1 className="mb-5 text-4xl leading-[1.2] md:mb-6 md:text-[50px] lg:text-[50px] font-bold">
          Über uns – Ihr führender Partner für Cybersicherheit          </h1>
          <h2 className="mb-1 text-3xl leading-[1.2] md:mb-6 md:text-[25px] lg:text-[25px] font-bold">Unsere Vision?</h2>
          <p className="text-text-alternative md:text-md font-bold text-xl text-shadow-lg drop-shadow-2xl">
          Ein sicheres Deutschland, in dem Unternehmen, Behörden und Institutionen gegen unsichtbare digitale Gefahren gewappnet sind.  </p>
        </div>
      </div>
      <div className="absolute inset-0 z-0">
      
        <div className="absolute inset-0 bg-[rgba(0,0,0,0.2)]" />
      </div>
    </section>
  );
}
